import { motion } from 'framer-motion';
import styled, { css } from 'styled-components';
import { FieldWrapper } from 'components';
import { theme, toRem } from 'design';

interface SidebarMobileActionsProps {
  columns?: number;
}

export const SidebarMobileActions = styled.div<SidebarMobileActionsProps>`
  display: flex;
  flex-flow: row nowrap;

  & > *:not(:last-child) {
    margin-right: ${toRem(8)};
  }

  @media (min-width: ${theme.breakpoint.large}px) {
    display: none;
  }
`;

export const SidebarContentLayout = styled.div`
  display: flex;
  flex-flow: column nowrap;
  justify-content: flex-start;
  align-items: flex-start;
  width: 100%;
`;

export const MessageContainer = styled.div`
  width: 100%;
  margin: ${toRem(10)};
`;

export const SidebarActions = styled.div`
  display: flex;
  flex-flow: row nowrap;
  margin-top: ${toRem(26)};
`;

const SidebarSectionStyles = css`
  display: flex;
  flex-flow: column nowrap;
  justify-content: flex-start;
  align-items: flex-start;
  width: 100%;
  height: auto;
  border-bottom: ${toRem(1)} solid ${theme.color.neutral[200]};
  overflow: hidden;
`;

export const SidebarSection = styled.section`
  ${SidebarSectionStyles}
  margin-bottom: ${toRem(24)};
  padding-bottom: ${toRem(24)};

  &:last-child {
    margin-bottom: 0;
  }
`;

export const SidebarSectionMobile = styled(SidebarSection)`
  padding-top: ${toRem(33)};
  border-top: ${toRem(1)} solid ${theme.color.neutral[200]};
  overflow: visible;

  @media (min-width: ${theme.breakpoint.large}px) {
    display: none;
  }
`;

export const SidebarHeaderSection = styled(SidebarSection)`
  @media (max-width: ${theme.breakpoint.large - 1}px) {
    flex-flow: row nowrap;
    justify-content: space-between;
    align-items: center;
    width: 100%;
    margin-bottom: ${toRem(33)};
    padding-bottom: 0;
    border-bottom: none;
  }

  margin-bottom: 0;
`;

interface IAnimatedSectionProps {
  isVisible?: boolean;
}

export const AnimatedSidebarSection = styled(motion.section)<IAnimatedSectionProps>`
  ${SidebarSectionStyles}
  border-bottom: none;

  ${({ isVisible }) =>
    isVisible &&
    css`
      margin-bottom: ${toRem(33)};
      padding-bottom: ${toRem(33)};
      border-bottom: ${toRem(1)} solid ${theme.color.neutral[200]};
    `}
`;

export const DescriptionFieldWrapper = styled(FieldWrapper)`
  > header {
    margin-bottom: ${toRem(18)};
  }
`;
